/* Add a whole sibling set to the cart. All pieces on the "his" side take his
     size, all on the "hers" side take hers. Posts one /cart/add.js request with
     3-4 line items, then hands Dawn's <cart-drawer> the rendered sections so the
     drawer opens without a page load. */
  (function () {
    document.querySelectorAll('.rk-lp .rk-addset').forEach(function (root) {
      var chosen = { his: null, hers: null };
      var btn = root.querySelector('.rk-addbtn');
      var msg = root.querySelector('.rk-addmsg');

      function maps(side) {
        return [].map.call(root.querySelectorAll('.rk-vm[data-side="' + side + '"]'), function (el) {
          return { title: el.dataset.title, v: JSON.parse(el.dataset.json) };
        });
      }
      function syncAvailability(side) {
        var ms = maps(side);
        root.querySelectorAll('.rk-sz[data-side="' + side + '"]').forEach(function (b) {
          var size = b.dataset.size;
          var ok = ms.every(function (m) { return m.v[size] && m.v[size].ok === 1; });
          b.disabled = !ok;
        });
      }
      ['his', 'hers'].forEach(syncAvailability);

      function refresh() {
        var ready = chosen.his && chosen.hers;
        btn.disabled = !ready;
        btn.textContent = ready ? 'Add the set to cart' : 'Choose both sizes';
      }
      refresh();

      root.querySelectorAll('.rk-sz').forEach(function (b) {
        b.addEventListener('click', function () {
          var side = b.dataset.side;
          root.querySelectorAll('.rk-sz[data-side="' + side + '"]').forEach(function (o) {
            o.setAttribute('aria-pressed', 'false');
          });
          b.setAttribute('aria-pressed', 'true');
          chosen[side] = b.dataset.size;
          msg.textContent = ''; msg.classList.remove('err');
          refresh();
        });
      });

      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var items = [];
        ['his', 'hers'].forEach(function (side) {
          maps(side).forEach(function (m) {
            var v = m.v[chosen[side]];
            if (v) items.push({ id: v.id, quantity: 1 });
          });
        });
        if (!items.length) return;
        btn.disabled = true; btn.textContent = 'Adding…';
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && window.routes) {
          body.sections = 'cart-drawer,cart-icon-bubble';
          body.sections_url = window.location.pathname;
        }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add');
            btn.textContent = 'Added to cart';
            if (drawer && res.j.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res.j);
            } else {
              window.location.href = '/cart';
            }
            setTimeout(function () { btn.disabled = false; btn.textContent = 'Add the set to cart'; }, 2200);
          })
          .catch(function (e) {
            msg.textContent = e.message + ' — try a different size, or message us on WhatsApp.';
            msg.classList.add('err');
            btn.disabled = false; btn.textContent = 'Add the set to cart';
          });
      });
    });
  })();
